module.exports = __webpack_public_path__ + "img/bg-word.e6aa8ff9.png";